"use client";

import React from "react";
import { ArrowRight, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function GetYourFreeValuation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="get-your-free-valuation" ref={ref} className={cn("dark bg-muted text-foreground py-16 md:py-20 relative overflow-hidden", "transition-opacity duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] mix-blend-overlay" />

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-white mb-2">
              Ready to see your property's potential?
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto md:mx-0">
              Get a comprehensive rental valuation from our local experts today.
            </p>
          </div>

          <div className="flex-shrink-0">
            <Dialog>
              <DialogTrigger asChild>
                <Button size="lg" className="bg-white text-black hover:bg-gray-200 text-base px-8 py-6 h-auto font-semibold rounded-none">
                  Request Free Valuation
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-[500px] bg-card text-card-foreground border-border">
                <DialogHeader>
                  <DialogTitle className="font-serif text-2xl">
                    Request a Free Valuation
                  </DialogTitle>
                  <DialogDescription>
                    Fill in your details below and one of our property experts
                    will be in touch shortly to arrange your free valuation.
                  </DialogDescription>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                  <div className="grid gap-2">
                    <label htmlFor="name" className="text-sm font-medium">
                      Full Name
                    </label>
                    <input id="name" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="John Doe" />
                  </div>
                  <div className="grid gap-2">
                    <label htmlFor="email" className="text-sm font-medium">
                      Email Address
                    </label>
                    <input id="email" type="email" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="john@example.com" />
                  </div>
                  <div className="grid gap-2">
                    <label htmlFor="phone" className="text-sm font-medium">
                      Phone Number
                    </label>
                    <input id="phone" type="tel" className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="+44 7700 900000" />
                  </div>
                  <div className="grid gap-2">
                    <label htmlFor="address" className="text-sm font-medium">
                      Property Address
                    </label>
                    <textarea id="address" className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50" placeholder="123 High Street, London..." />
                  </div>
                </div>
                <div className="flex flex-col gap-3">
                  <Button className="w-full bg-primary text-primary-foreground hover:bg-primary/90">
                    Submit Request
                  </Button>
                  <p className="text-xs text-center text-muted-foreground">
                    By submitting this form, you agree to our privacy policy.
                  </p>
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </div>
    </section>;
}